import { api } from './api'
import { manuallyUpdateTicketCacheSubscription } from './tickets'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'subscription',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    createTicketSubscription: builder.mutation({
      query: ({ ticketingSystemDisplayId, ticketId }) => {
        return ({
          url: `/subscriptions/ticketing_systems/${ticketingSystemDisplayId}/tickets/${ticketId}`,
          method: 'POST',
        })
      },
      onQueryStarted: manuallyUpdateTicketCacheSubscription,
    }),

    removeTicketSubscription: builder.mutation({
      query: ({ ticketingSystemDisplayId, ticketId }) => {
        return ({
          url: `/subscriptions/ticketing_systems/${ticketingSystemDisplayId}/tickets/${ticketId}`,
          method: 'DELETE',
        })
      },
      onQueryStarted: manuallyUpdateTicketCacheSubscription,
    }),

    fetchTicketsSubscriptions: builder.query({
      query: ({ ticketingSystemDisplayId, params }) => {
        return ({
          url: `/subscriptions/ticketing_systems/${ticketingSystemDisplayId}/tickets`,
          params: {
            ...(params.searchValue && { restrictSearch: params.searchValue }),
            ...(params.sortField && { sortField: params.sortField }),
            ...(params.sortDir && { sortDir: params.sortDir }),
            page: params.page,
          },
        })
      },
      providesTags: (result) => [{ type: 'subscription', id: 'LIST' }],
    }),

    subscribeToTicketsViews: builder.mutation({
      query: ({ ticketingSystemDisplayId, storedParams }) => {
        return ({
          url: `/subscriptions/ticketing_systems/${ticketingSystemDisplayId}/views`,
          method: 'POST',
          body: { storedParams: storedParams },
        })
      },
    }),

    unsubscribeToTicketsViews: builder.mutation({
      query: ({ ticketingSystemDisplayId, storedParams }) => {
        return ({
          url: `/subscriptions/ticketing_systems/${ticketingSystemDisplayId}/views`,
          method: 'DELETE',
          body: { storedParams: storedParams },
        })
      },
      invalidatesTags: ['viewsSubscription'],
    }),

    fetchTicketsViewsSubscriptions: builder.query({
      query: ({ ticketingSystemDisplayId, params }) => {
        return ({
          url: `/subscriptions/ticketing_systems/${ticketingSystemDisplayId}/views`,
          params: {
            ...(params.searchValue && { search: params.searchValue }),
            ...(params.sortField && { sortField: params.sortField }),
            ...(params.sortDir && { sortDir: params.sortDir }),
            page: params.page,
          },
        })
      },
      providesTags: (result) => [{ type: 'viewsSubscription', id: 'LIST' }],
    }),

    removeSubscription: builder.mutation({
      query: ({ ticketingSystemDisplayId, ticketId }) => ({
        url: `/subscriptions/ticketing_systems/${ticketingSystemDisplayId}/tickets/${ticketId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['subscription'],
    }),

    fetchAdminTicketsSubscriptions: builder.query({
      query: ({ ticketProviderId, params }) => {
        return ({
          url: `/admin/subscriptions/ticket_providers/${ticketProviderId}/tickets`,
          params: {
            ...(params.searchValue && { search: params.searchValue }),
            ...(params.partnerFilter && { partnerFilter: params.partnerFilter }),
            ...(params.statusFilter && { statusFilter: params.statusFilter }),
            ...(params.sortField && { sortField: params.sortField }),
            ...(params.sortDir && { sortDir: params.sortDir }),
            page: params.page,
          },
        })
      },
    }),

    fetchAdminTicketsViewsSubscriptions: builder.query({
      query: ({ ticketProviderId, params }) => {
        return ({
          url: `/admin/subscriptions/ticket_providers/${ticketProviderId}/views`,
          params: {
            ...(params.searchValue && { search: params.searchValue }),
            ...(params.partnerFilter && { partnerFilter: params.partnerFilter }),
            ...(params.sortField && { sortField: params.sortField }),
            ...(params.sortDir && { sortDir: params.sortDir }),
            page: params.page,
          },
        })
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useCreateTicketSubscriptionMutation,
  useRemoveTicketSubscriptionMutation,
  useFetchTicketsSubscriptionsQuery,
  useSubscribeToTicketsViewsMutation,
  useUnsubscribeToTicketsViewsMutation,
  useFetchTicketsViewsSubscriptionsQuery,
  useRemoveSubscriptionMutation,
  useFetchAdminTicketsSubscriptionsQuery,
  useFetchAdminTicketsViewsSubscriptionsQuery,
} = extendedApi
